import React from "react";
import QrReader from "react-qr-reader";
import validate from "uuid-validate";
import { CButton, CContainer } from "@coreui/react";

import { useApp } from "context/appContext";
import BookingByID from "components/BookingByID";
import Header from "components/Header";

import "./styles.css";

function Scanner({
  onHandleScan,
  showCC,
  onHandleShowCC,
  onHandleHideCC,
  onGetReservationByCC,
  events
}) {
  const { showNotification } = useApp();

  const handleScan = (data) => {
    if (data) {
      if (!validate(data)) {
        showNotification("El código escaneado no es un QR valido para ingreso.", "error");
        return;
      }
      onHandleScan(data);
    }
  };
  const handleError = (err) => {
    console.error(err);
  };
  const previewStyle = {
    width: "100%",
  };
  const mapEvents = () =>
    events.map(({ id, description }) => ({
      value: id,
      label: description,
    }));
  return (
    <CContainer className="text-center">
      <Header showFinish />
      {showCC ? (
        <BookingByID
          getReservation={onGetReservationByCC}
          events={mapEvents()}
          onCancel={onHandleHideCC}
        />
      ) : (
        <>
          <br />
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={previewStyle}
            facingMode="environment"
          />
          <br />
          <CButton onClick={onHandleShowCC} color="primary">
            Buscar por cédula
          </CButton>
        </>
      )}
    </CContainer>
  );
}

export default Scanner;
